import {BASIC_MODEL_PHOTOS} from '../../config/basicModelPhotos';
import {BASIC_BED_PRICE} from '../../../shared/basicBedPricing';
import type {PreviewLayout} from './photo/ernst-layout';
// Owner-approved starting prices; a scoped proposal confirms each custom build.
export const CUSTOM_STARTING_PRICE = 24995;
export const CASTLE_STARTING_PRICE = 149995;
export type LandingCollection='Basic'|'Custom'|'Themes';
export type LandingModel={ladderFlipped?:boolean;id:string;name:string;collection:LandingCollection;layout:PreviewLayout;choice:number;image?:string;price?:string;disabled?:boolean};
export const LANDING_MODELS:Record<LandingCollection,LandingModel[]>={
  "Basic": [
    {
      "id": "basic-0",
      "name": "Twin over Twin",
      "image": BASIC_MODEL_PHOTOS[0].url,
      "price": BASIC_BED_PRICE.toLocaleString("en-US",{minimumFractionDigits:2}),
      "collection": "Basic",
      "layout": "basic",
      "choice": 0
    },
    {
      "id": "basic-1",
      "name": "Twin XL over Twin XL",
      "image": BASIC_MODEL_PHOTOS[1].url,
      "price": BASIC_BED_PRICE.toLocaleString("en-US",{minimumFractionDigits:2}),
      "collection": "Basic",
      "layout": "basic",
      "choice": 1
    },
    {
      "id": "basic-2",
      "name": "Twin over Full",
      "image": BASIC_MODEL_PHOTOS[2].url,
      "price": BASIC_BED_PRICE.toLocaleString("en-US",{minimumFractionDigits:2}),
      "collection": "Basic",
      "layout": "basic",
      "choice": 2
    },
    {
      "id": "basic-3",
      "name": "Twin XL over Queen",
      "image": BASIC_MODEL_PHOTOS[3].url,
      "price": BASIC_BED_PRICE.toLocaleString("en-US",{minimumFractionDigits:2}),
      "collection": "Basic",
      "layout": "basic",
      "choice": 3
    },
    {
      "id": "basic-4",
      "name": "Queen over Queen",
      "image": BASIC_MODEL_PHOTOS[4].url,
      "price": BASIC_BED_PRICE.toLocaleString("en-US",{minimumFractionDigits:2}),
      "collection": "Basic",
      "layout": "basic",
      "choice": 4
    },
    {
      "id": "basic-5",
      "name": "Full over Full",
      "image": BASIC_MODEL_PHOTOS[5].url,
      "price": BASIC_BED_PRICE.toLocaleString("en-US",{minimumFractionDigits:2}),
      "collection": "Basic",
      "layout": "basic",
      "choice": 5
    }
  ],
  "Custom": [
    {
      "id": "ernst",
      "name": "Ernst",
      "image": "/media/portfolio/curated-82662.jpg",
      "price": CUSTOM_STARTING_PRICE.toLocaleString("en-US",{minimumFractionDigits:2}),
      "collection": "Custom",
      "layout": "ernst",
      "choice": 0
    }
  ],
  "Themes": [
    {
      "id": "castle",
      "name": "Castle",
      "image": "/media/bliss-custom/storybook-castle.jpg",
      "price": CASTLE_STARTING_PRICE.toLocaleString("en-US",{minimumFractionDigits:2}),
      "collection": "Themes",
      "layout": "castle",
      "choice": 0
    },
    {
      "id": "ship",
      "name": "Ship Bunks — No Live Preview",
      "disabled": true,
      "collection": "Themes",
      "layout": "castle",
      "choice": 0
    }
  ]
};
export const ERNST_LANDING_MODEL=LANDING_MODELS.Custom[0];



